import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Manage from "src/components/SearchExpireds/Manage";
import SearchExpireds from "src/components/SearchExpireds";
import ProtectedFeaturePage from "src/components/common/ProtectedFeaturePage";

const SearchExpiredsPage = () => {
  return (
    <>
      <Routes>
        <Route
          path="search"
          element={
            <ProtectedFeaturePage featureKey="expireds" productName="Expireds">
              <SearchExpireds />
            </ProtectedFeaturePage>
          }
        />
        <Route
          path="manage"
          element={
            <ProtectedFeaturePage featureKey="expired_upload" productName="Upload Expireds">
              <Manage />
            </ProtectedFeaturePage>
          }
        />
        <Route index element={<Navigate to="search" />} />
      </Routes>
      <Outlet />
    </>
  );
};

export default SearchExpiredsPage;
